import { makeObservable, observable, action } from "mobx";
import { makePersistable } from 'mobx-persist-store';

class Store {
    user = "";
    userRole = {}
    password = "";
    token = ""
    successMessage = null
    statusMessage = null
    errorMessage = null
    currentNetworkRun = {}
    networkRuns = [];
    networkBatches = [];
    currentNetworkBatch = {}
    networkRunQueues = [];
    instrumentNoiseSeparationInputs = [];
    heatMaps = [];
    analyticsFiles = [];
    persisterFiles = [];
    audioFiles = [];
    inputAudioFiles = [];
    musicFiles = [];

    constructor() {
        makeObservable(this, {
            user: observable,
            userRole: observable,
            password: observable,
            token: observable,
            successMessage: observable,
            statusMessage: observable,
            errorMessage: observable,
            currentNetworkRun: observable,
            networkRuns: observable,
            currentNetworkBatch: observable,
            networkRunQueues: observable,
            networkBatches: observable,
            instrumentNoiseSeparationInputs: observable,
            heatMaps: observable,
            analyticsFiles: observable,
            persisterFiles: observable,
            inputAudioFiles: observable,
            audioFiles: observable,
            musicFiles: observable,
            updateUser: action,
            updatePassword: action,
            updateToken: action,
            updateSuccessMessage: action,
            updateStatusMessage: action,
            updateErrorMessage: action,
            updateCurrentNetworkRun: action,
            updateNetworkRunQueues: action,
            updateInstrumentNoiseSeparationInputs: action,
            updateHeatMaps: action,
            updateAnalyticsFiles: action,
            updateAudioFiles: action,
            updateInputAudioFiles: action,
            updateMusicFiles: action,
            updateNetworkRuns: action,
            updateNetworkBatches: action,
        })
        makePersistable(this, {
            name: 'Store',
            properties: ['user', 'userRole', 'password', 'token', 'currentNetworkRun', 'instrumentNoiseSeparationInputs', 'heatMaps', 'analyticsFiles', 'persisterFiles', 'audioFiles', 'inputAudioFiles', 'musicFiles', 'networkRuns', 'networkBatches', 'networkRunQueues', 'currentNetworkBatch'],
            storage: window.localStorage
        });
    }

    updateUser = (val) => {
        this.user = val;
    }
    updateUserRole = (val) => {
        this.userRole = val;
    }
    updatePassword = (val) => {
        this.password = val;
    }
    updateToken = (val) => {
        this.token = val;
    }
    updateSuccessMessage = (val) => {
        this.successMessage = val;
    }
    updateStatusMessage = (val) => {
        this.statusMessage = val;
    }
    updateErrorMessage = (val) => {
        this.errorMessage = val;
    }
    updateToken = (val) => {
        this.token = val;
    }
    updateCurrentNetworkRun = (val) => {
        this.currentNetworkRun = val;
    }
    updateNetworkRuns = (val) => {
        this.networkRuns = val;
    }
    updateCurrentNetworkBatch = (val) => {
        this.currentNetworkBatch = val;
    }
    updateNetworkRunQueues = (val) => {
        this.networkRunQueues = val;
    }
    updateNetworkBatches = (val) => {
        this.networkBatches = val;
    }
    updateInstrumentNoiseSeparationInputs = (val) => {
        this.instrumentNoiseSeparationInputs = val;
    }
    updateHeatMaps = (val) => {
        this.heatMaps = val;
    }
    updateAnalyticsFiles = (val) => {
        this.analyticsFiles = val;
    }
    updatePersisterFiles = (val) => {
        this.persisterFiles = val;
    }
    updateAudioFiles = (val) => {
        this.audioFiles = val;
    }
    updateInputAudioFiles = (val) => {
        this.inputAudioFiles = val;
    }
    updateMusicFiles = (val) => {
        this.musicFiles = val;
    }
}

let store;
export function getStore() {
    if (!store)
        store = new Store();
    return store;
};
